import React from 'react';

const Background = (props) => (
  <div className="searchSections-background" {...props} />
);

export default Background;
